import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  ProductionBoardPage,
  productionBoardQueryOptions,
  productionBoardSearchSchema,
} from '@/features/production';

export const Route = createFileRoute('/_authed/_active/s/$storeId/production')({
  validateSearch: productionBoardSearchSchema,
  loaderDeps: ({ search }) => search,
  staticData: { crumb: 'common:nav.production', tours: ['production.board'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: ({ context, params, deps }) =>
    context.queryClient
      .infiniteQuery({ ...productionBoardQueryOptions(params.storeId, deps), staleTime: 'static' })
      .catch(() => undefined),
  component: ProductionBoardPage,
});
